import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconColoredBook: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <rect width="24" height="24" rx="4" fill="#9696FF" />
      <g clipPath="url(#clip0)">
        <path
          d="M17.3929 5.22419H16.7906V4.62186C16.7906 3.70821 16.0472 2.96484 15.1336 2.96484H8.92027C8.78046 2.96484 8.64629 3.02046 8.54742 3.11934L5.1584 6.50835C5.05952 6.60723 5.00391 6.7414 5.00391 6.8812V17.0485C5.00391 17.9622 5.74727 18.7055 6.66092 18.7055H7.26325V19.3079C7.26325 19.7508 7.43573 20.1669 7.74857 20.4791C8.06127 20.7924 8.47752 20.9649 8.9204 20.9649H17.3931C18.3067 20.9649 19.0501 20.2215 19.0501 19.3079V6.8812C19.0501 5.96755 18.3067 5.22419 17.3929 5.22419ZM8.95776 4.2004V6.31637C8.95776 6.64857 8.68763 6.91869 8.35543 6.91869H6.2396L8.95776 4.2004ZM6.0586 17.0485V7.97352H8.35543C9.26908 7.97352 10.0124 7.23016 10.0124 6.3165V4.01953H15.1336C15.4657 4.01953 15.7359 4.2898 15.7359 4.62186V17.0485C15.7359 17.3806 15.4657 17.6508 15.1336 17.6508H6.66092C6.32872 17.6508 6.0586 17.3806 6.0586 17.0485ZM17.9954 19.3079C17.9954 19.6399 17.7251 19.9102 17.3931 19.9102H8.9204C8.75945 19.9102 8.60839 19.8476 8.49427 19.7334C8.38056 19.6199 8.31794 19.4687 8.31794 19.3079V18.7055H15.1336C16.0474 18.7055 16.7906 17.9622 16.7906 17.0485V6.27888H17.3931C17.7251 6.27888 17.9954 6.54914 17.9954 6.8812V19.3079Z"
          fill="white"
        />
        <path
          d="M8.35547 10.7979H13.4391C13.7304 10.7979 13.9665 10.5618 13.9665 10.2705C13.9665 9.97924 13.7304 9.74316 13.4391 9.74316H8.35547C8.06433 9.74316 7.82812 9.97924 7.82812 10.2705C7.82812 10.5618 8.06433 10.7979 8.35547 10.7979Z"
          fill="white"
        />
        <path
          d="M8.35547 13.0566H13.4391C13.7304 13.0566 13.9665 12.8206 13.9665 12.5293C13.9665 12.238 13.7304 12.002 13.4391 12.002H8.35547C8.06433 12.002 7.82812 12.238 7.82812 12.5293C7.82812 12.8206 8.06433 13.0566 8.35547 13.0566Z"
          fill="white"
        />
        <path
          d="M8.35547 15.3164H11.1798C11.4709 15.3164 11.7071 15.0803 11.7071 14.7891C11.7071 14.4979 11.4709 14.2617 11.1798 14.2617H8.35547C8.06433 14.2617 7.82812 14.4979 7.82812 14.7891C7.82812 15.0803 8.06433 15.3164 8.35547 15.3164Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(3 3)"
          />
        </clipPath>
      </defs>
    </Icon>
  );
};

export default IconColoredBook;
